// Look for .hamburger
var hamburger = document.querySelector(".hamburger");
var navDropDown = document.querySelector(".collapse.navbar-collapse");
// On click
hamburger.addEventListener("click", function() {
    // Toggle class "is-active"
    hamburger.classList.toggle("is-active");
    // Do something else, like open/close menu
    navDropDown.classList.toggle("show");

});